<template>
  <div class="container-fluid bg-card-linear">
    <div class="row moreAbout">
      <div class="col">
        <div class="row">
          <div class="col">
            <div>{{$t('maintenance_Followup')}}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-auto col-md-10 valuedPartner">
            <div>
              {{$t('valuedPartner')}}
            </div>
          </div>
          <div class="col-auto col-md-10 text-start content-center" v-if="val.expireDate">
            <span>{{$t('renewal')}}</span>
            <span class="mx-2">{{moment(val.expireDate).format('LL')}}</span>
          </div>
          <div class="col-auto active_system content-center">
            <span class="circle"></span>
            <span class="mx-2">{{$t('maintenanceSystem')}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div class="row">
      <div class="col pt-4">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('citiesList.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active mx-3" aria-current="page">{{$t('subscriptionPackages')}}</li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="text-center">
      <errorAlert v-if="hasError" :alertMessage="message" :errorNumber='errorNumber' />
    </div>
    <div v-if="isLoading" class="row justify-content-center">
      <div class="col-12 col-md-8 text-center">
        <mainloader />
      </div>
    </div>

    <div v-else class="row">
      <div class="col-12">
        <!--begin:packages list !subscription -->
        <div class="row">
          <div class="col-12 col-md-6 subscription" v-for="(row,index) in rows" :key="index">
            <div class="card">
              <div class="card-body">
                <img :src="MEDIA_URL+row.image" class="img-fluid" alt="">
                <div class="row title">
                  <div class="col">
                    {{row.title}}
                  </div>
                  <div class="col-auto">
                    <span>{{row.price}}</span>
                    <span class="mx-1">{{$t('currency')}}</span>
                  </div>
                </div>
                <div class="row pt-2">
                  <div class="col description">
                    {{row.description}}
                  </div>
                </div>
              <div>
            </div>
            <!-- <div class="card target">
              <div class="card-body">
                <div class="almarai-bold">{{$t('target')}}</div>
                <div class="row p-2">
                  <div class="col-auto">
                    <img src="/assets/images/icons/user.png" class="max-16" alt="">
                    <span class="mx-1">{{$t('homeowners')}}</span>
                  </div>
                  <div class="col-auto mx-2">
                    <img src="/assets/images/icons/home.png" class="max-16" alt="">
                    <span class="mx-1">{{$t('apartmentOwners')}}</span>
                  </div>
                </div>
              </div>
            </div> -->

                <!-- <div class="row pt-3">
                  <div class="col">
                    <div class="card featuresIncluded">
                      <div class="card-body">
                        <div class="almarai-bold">{{$t('featuresIncluded')}}</div>
                        <div class="row features">
                          <div class="col-12" v-for="(val, indx) in row.features" :key="indx">
                            <span>
                              <img src="/assets/images/icons/tick-circle.png" class="w-24"  alt="">
                            </span>
                            <span class="mx-2">{{val}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->

                <!-- <div class="row pt-3">
                  <div class="col">
                    <div class="card featuresIncluded">
                      <div class="card-body">
                        <div class="almarai-bold">{{$t('termsConditions')}}</div>
                        <div class="row features">
                          <div class="col-12">
                            {{row.terms}} .
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> -->

                <div class="row py-3 justify-content-center">
                  <div class="col-9 col-md-6 btn-green text-center">
                    <router-link v-if="row.isSubscribed" :to="'/detailsMaintenance/'+row.subscriptionId" class="text-white">
                      <div class="btnpackageDetails">{{$t('packageDetails')}}</div>
                    </router-link>
                    <router-link v-if="!row.isSubscribed" :to="'/detailsMaintenance?packageID='+row.id" class="text-white">
                      <div class="btnpackageDetails">{{$t('packageDetails')}}</div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end:packages list !subscription -->
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
  name:"packagesList",
  data(){
    return{
      isLoading: true,
      hasError: false,
      message: '',
      errorNumber: null,
      rows:[],
      val: {},
      statusChoices: {},
      userPackageUsages: [],
      userLang: 'ar',
    }
  },
  computed: {
    ...mapGetters(['MEDIA_URL','GET_USER'])
  },
  methods: {
    async packageList(){
      await this.$http.get('/api/mPackages/list').then(res => {
        this.rows = res.data.rows;
        this.activeSubscriptions = res.data.activeSubscriptions;
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      })
    },

    moment,
    formatDate(){
      this.nowTime = new Date();
      this.hours = this.nowTime.getHours().toString().padStart(2, '0');
      this.minutes = this.nowTime.getMinutes().toString().padStart(2, '0');
      this.formattedTime = `${this.hours}:${this.minutes}`;
      // console.log(this.formattedTime);
    },
  },
  created(){
    this.packageList();
    window.scrollTo({top:0, behavior: 'smooth'});
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }
}
</script>